import React, { useContext, useState } from "react";
import { FaGithubSquare } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";
import { Link } from "react-router-dom";
import { ThemeContext } from "../contexts/ThemeContext";

export default function ProjectCard({ project }) {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const toggleTooltip = () => {
    setTooltipVisible(!tooltipVisible);
  };

  const { darkMode } = useContext(ThemeContext);

  const isGithub = project.github ? true : false;

  return (
    <div
      key={project.id}
      className="bg-neutral-50 dark:bg-neutral-800 p-5 rounded-lg"
    >
      {darkMode ? (
        <img
          className="w-full h-auto rounded-lg"
          src={project.img[1]}
          alt="img"
        />
      ) : (
        <img
          className="w-full h-auto rounded-lg"
          src={project.img[0]}
          alt="img"
        />
      )}
      <div className="pt-5 text-white">
        <div className="flex gap-2 mb-4">
          <div className="w-9/12 flex justify-start items-start flex-wrap gap-y-2">
            {project.languages?.map((lang, index) => (
              <span
                key={index}
                className="px-2 py-1 mr-2 rounded bg-neutral-900 text-sm text-neutral-100 font-semibold whitespace-nowrap"
              >
                {lang}
              </span>
            ))}
          </div>
          <div className="w-3/12 flex gap-2 justify-end items-start">
            <div className="relative">
              <Link
                onMouseEnter={toggleTooltip}
                onMouseLeave={toggleTooltip}
                to={isGithub ? project.github : ""}
                target={isGithub ? "_blank" : ""}
                className={`block bg-transparent transition duration-300 text-3xl text-neutral-700 hover:text-neutral-800 dark:text-neutral-300 dark:hover:text-neutral-100 ${
                  isGithub ? "cursor-pointer" : "cursor-default opacity-50"
                }`}
              >
                <FaGithubSquare size={25} />{" "}
              </Link>{" "}
              {!isGithub && tooltipVisible && (
                <div className="absolute right-full top-0 z-10 flex items-center px-3 mr-2 h-full text-sm font-medium text-white duration-300 bg-gray-900 rounded shadow-sm tooltip dark:bg-gray-700 whitespace-nowrap">
                  Private Repo
                </div>
              )}
            </div>

            <a
              href={project.liveDemo}
              target="_blank"
              rel="noreferrer"
              className="block bg-transparent transition duration-300 text-3xl text-neutral-700 hover:text-neutral-800 dark:text-neutral-300 dark:hover:text-neutral-100"
            >
              <FiExternalLink size={25} className="cursor-pointer" />
            </a>
          </div>
        </div>

        <h4 className="text-2xl font-semibold text-neutral-900 dark:text-neutral-100 mb-2">
          {project.title}
        </h4>
        <p
          className="text-lg text-neutral-900 dark:text-neutral-100"
          dangerouslySetInnerHTML={{ __html: project.description }}
        />
      </div>
    </div>
  );
}
